import React from 'react';

import Input from '../../forms/inputs/Input';
import DateSelect from '../../forms/dates/dateSelect';
import UserCreateFormRole from './Users.create.roleSelect';
import CreateUserPhoneList from './Users.create.phoneList';
import CreateUserAddressList from './Users.create.addressList';
import { useTranslation } from 'react-i18next';
import Checkbox from "../../forms/inputs/Checkboxk";
import {PAGES} from "../../services/interactions/audit.trail";
export default function CreateUserForm({event, dataFields, defaultCountry}){
    const {t} = useTranslation(['users'])
    const enableReceiveAlerts = () => {
        return dataFields['role'].value && dataFields['role'].value === 'clinician';
    }
    return(
        <div className="formContent">
            <h3>{t('role-privileges')}</h3>
            <div className="row three">
                <UserCreateFormRole event={event} role={dataFields['role'].value} onChange={dataFields['userRoles'].onChange} onLabelChange={dataFields['role'].onChange}/>
            </div>
            <h3>{t('user-info')}</h3>
            <div className="row two">
                <Input required={dataFields['bio.lastname'].required} error={dataFields['bio.lastname'].error} value={dataFields['bio.lastname'].value} label={t('last-name')} onChange={dataFields['bio.lastname'].onChange} event={event}/>
                <Input required={dataFields['bio.firstname'].required} error={dataFields['bio.firstname'].error} value={dataFields['bio.firstname'].value} label={t('first-name')} onChange={dataFields['bio.firstname'].onChange} event={event}/>
            </div>
            <div className="row two left">
                <DateSelect event={event} required={dataFields['dateOfBirth'].required} error={dataFields['dateOfBirth'].error} value={dataFields['dateOfBirth'].value} onChange={dataFields['dateOfBirth'].onChange} asNumber={true} />
            </div>
            <div className="row hasEmail">
                <Input required={dataFields['email'].required} regexTest={/^\S+@\S+\.\S+$/} error={dataFields['email'].error} errorMessage={dataFields['email'].errorMessage} value={dataFields['email'].value}
                       onChange={dataFields['email'].onChange} placeholder={t('email-address')} label={t('email-address')} event={event}/>
                {
                    enableReceiveAlerts()?
                        <Checkbox label={t('Receive Email Alerts')} onChange={() => {}} bool={dataFields['receiveEmail'].value} vertical={true} disabled={true} event={event} /> : ''
                }
            </div>
            <CreateUserPhoneList event={event} prefix="user" defaultCountry={defaultCountry} required={dataFields['phones'].required} error={dataFields['phones'].error} phones={dataFields['phones'].value} onChange={dataFields['phones'].onChange} displaySMSAlerts={enableReceiveAlerts()} />
            <div className="divider"></div>
            <h3>{t('address')}</h3>
            <CreateUserAddressList event={event} error={dataFields['address'].error} defaultCountry={defaultCountry} address={dataFields['address'].value} onChange={dataFields['address'].onChange} arrayRequired={dataFields['address'].arrayRequired} />
        </div>
    )
}
